export default "__VITE_ASSET__ad8ccc66__"